'use client'

import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { createBrowserSupabaseClient } from '@/lib/supabase/browser'

export function SignOutButton() {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  async function handleSignOut() {
    setLoading(true)
    const supabase = createBrowserSupabaseClient()
    await supabase.auth.signOut()
    await fetch('/api/auth/signout', { method: 'POST' })
    router.replace('/login')
    router.refresh()
    setLoading(false)
  }

  return (
    <button type="button" className="btn-secondary" onClick={handleSignOut} disabled={loading}>
      {loading ? 'Déconnexion…' : 'Se déconnecter'}
    </button>
  )
}
